module.exports = __webpack_public_path__ + "img/ueber-mich-2_1920.62f93a09.webp";